module.exports = __webpack_public_path__ + "img/bg.8ee13a92.png";